import { css } from '@leafygreen-ui/emotion';
import { spacing } from '@leafygreen-ui/tokens';

export const rootStyles = css`
  width: 100%;
`;

export const headerStyles = css`
  width: 250px;
  margin-bottom: 20px;
`;

export const lineStyles = css`
  margin-bottom: ${spacing[3]}px;
`;

export const lastLineStyles = css`
  width: 350px;
`;
